import React from "react";
import { connect } from "react-redux";
import Parser from "html-react-parser";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Button from "../shared/button/Button";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  CloseButton,
  ButtonsWrapper,
} from "./styles/about-agent-modal-styles";

export const AboutAgentModal = ({
  aboutAgent,
  toggleAboutAgentModal,
  user,
}) => (
  <Backdrop className="animated fadeIn">
    <ModalWrapper className="animated delay-1 fadeInDown">
      <Title>
        <TitleText>
          About {user.firstName} {user.lastName}
        </TitleText>
        <CloseButton onClick={() => toggleAboutAgentModal()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
      </Title>
      <Body>{Parser(aboutAgent)}</Body>
      <ButtonsWrapper>
        <Button
          primary
          buttonName="Close"
          onClickAction={() => toggleAboutAgentModal()}
        />
      </ButtonsWrapper>
    </ModalWrapper>
  </Backdrop>
);

AboutAgentModal.propTypes = {
  aboutAgent: PropTypes.string.isRequired,
  toggleAboutAgentModal: PropTypes.func.isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  aboutAgent: state.agencyProfile.profileData.aboutAgent,
  user: state.agencyProfile.profileData.user,
});

export default connect(mapStateToProps, {})(AboutAgentModal);
